import React from "react";
import styles from "./AboutParallelogram.module.scss";
import BlueHoleIcon from "../../../../public/logo.png";
import Link from "next/link";

import ParallelogramImage from "../../HomePage/ParallelogramImage/ParallelogramImage";
import Button from "../../shared/Button/Button";

import { FormattedMessage } from "react-intl";
import Image from "next/future/image";
import { Col, Container, Row } from "react-bootstrap";
export default function AboutParallelogram({
  primaryText,
  secondaryText,
  backgroundPath,
  withButton,
  onClickButtonFunction,
  imageMeta,
}) {
  return (
    <div className={styles.AboutParallelogram}>
      <Container>
        <Row className="justify-content-between   align-items-center">
          {backgroundPath && (
            <Col lg={5} xs={12}>
              <div className="img-wrapper">
                <Image
                  src={backgroundPath}
                  alt={imageMeta || "ParallelogramImage"}
                  className="img"
                  priority={true}
                  width={1920}
                  height={1080}
                />
              </div>
            </Col>
          )}

          <Col lg={6} xs={12}>
            <div className={styles["flex-col"]}>
              <div className={styles.flex}>
                {primaryText && (
                  <>
                    <h3>
                      <FormattedMessage id="who-we-are" />
                    </h3>
                  </>
                )}
              </div>

              {primaryText && (
                <div className={styles.flex}>
                  <h2>{primaryText}</h2>
                </div>
              )}

              {secondaryText && (
                <div
                  className={styles["dangerous-text"]}
                  dangerouslySetInnerHTML={{ __html: secondaryText }}
                ></div>
              )}

              <div className={styles["action-row"]}>
                {withButton && (primaryText || secondaryText) ? (
                  <Button
                    buttonColor="black"
                    buttonShape="square"
                    buttonText={<FormattedMessage id="read-more" />}
                    onClick={onClickButtonFunction}
                  />
                ) : null}

                <Link href="/contactus" passHref>
                  <a className={styles["cta-button-red"]}>
                    <FormattedMessage id="contact-us" />
                    <div className={styles["icon-circle"]}>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.53577 3.53556L14.1424 14.1422"
                          stroke="black"
                          strokeWidth={1.5}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553"
                          stroke="black"
                          strokeWidth={1.5}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
